import React, { useState, useRef } from 'react';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import CompanionChat from './pages/CompanionChat';
import JournalEntry from './pages/JournalEntry';
import MoodLog from './pages/MoodLog';
import HistoryPage from './pages/HistoryPage';
import './index.css';

function App() {
  const [currentPage, setCurrentPage] = useState('landing');
  const [userId] = useState('00000000-0000-0000-0000-000000000001'); // David's demo ID
  // Persistent conversation across page navigation
  const conversationRef = useRef([]);

  const navigate = (page) => setCurrentPage(page);

  const pages = {
    landing: <LandingPage navigate={navigate} />,
    dashboard: <Dashboard navigate={navigate} userId={userId} />,
    companion: <CompanionChat navigate={navigate} userId={userId} conversationRef={conversationRef} />,
    journal: <JournalEntry navigate={navigate} userId={userId} />,
    mood: <MoodLog navigate={navigate} userId={userId} />,
    history: <HistoryPage navigate={navigate} userId={userId} />,
  };

  return pages[currentPage] || pages.landing;
}

export default App;
